<script setup lang="ts">
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { cl_api, cl_errorMessage } from '@/api';

const cl_route = useRoute(); const cl_router = useRouter();
const cl_token = ref(String(cl_route.query.cl_token ?? '')); const cl_email = ref(''); const cl_password = ref('');
const cl_sent = ref(false); const cl_error = ref(''); const cl_loading = ref(false);
async function cl_submit() {
  cl_loading.value = true; cl_error.value = '';
  try {
    if (cl_token.value) { await cl_api.post('/auth/reset-password', { cl_token: cl_token.value, cl_password: cl_password.value }); await cl_router.push('/login'); }
    else { await cl_api.post('/auth/forgot-password', { cl_email: cl_email.value }); cl_sent.value = true; }
  } catch (cl_cause) { cl_error.value = cl_errorMessage(cl_cause); }
  finally { cl_loading.value = false; }
}
</script>

<template>
  <section class="cl-centered-page"><div class="cl-panel cl-onboarding"><p class="cl-eyebrow">Account recovery</p><h1>{{ cl_token ? '设置新密码' : '找回密码' }}</h1><p v-if="cl_sent">如果该邮箱已注册，重置邮件已经发送，请在 30 分钟内完成操作。</p><form v-else @submit.prevent="cl_submit"><label v-if="!cl_token">注册邮箱<input v-model.trim="cl_email" type="email" autocomplete="email" required /></label><label v-else>新密码<input v-model="cl_password" type="password" autocomplete="new-password" minlength="10" required /></label><p v-if="cl_error" class="cl-form-error">{{ cl_error }}</p><button class="cl-primary-button" :disabled="cl_loading">{{ cl_token ? '更新密码' : '发送重置邮件' }}</button><RouterLink class="cl-text-link" to="/login">返回登录</RouterLink></form></div></section>
</template>
